(() => {
  if (customElements.get('techtic-stitch')) return;
  const money = (cents) => new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(cents / 100);
  let widgetLibrary;
  let sequence = 0;
  let helpTrigger;
  const help = document.getElementById('tt-stitch-help');
  if (help) {
    help.addEventListener('click', (event) => {
      if (event.target.closest('[data-stitch-close]') || event.target === help) help.close();
    });
    help.addEventListener('close', () => {
      document.documentElement.classList.remove('tt-stitch-help-open');
      if (helpTrigger?.isConnected) helpTrigger.focus();
      helpTrigger = undefined;
    });
  }
  function loadWidgetLibrary() {
    if (window.StitchBNPL?.createWidget) return Promise.resolve(window.StitchBNPL);
    if (!widgetLibrary) {
      widgetLibrary = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://express.stitch.money/js/bnpl-widget.v1.js';
        script.async = true;
        script.dataset.autoInit = 'false';
        script.onload = () => window.StitchBNPL?.createWidget ? resolve(window.StitchBNPL) : reject(new Error('Stitch widget unavailable'));
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return widgetLibrary;
  }
  class TechTicStitch extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.months = 6;
      this.price = Number(this.dataset.price);
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-stitch-help]');
        if (trigger && help && !help.open) {
          helpTrigger = trigger;
          help.showModal();
          document.documentElement.classList.add('tt-stitch-help-open');
          return;
        }
        const button = event.target.closest('[data-stitch-months]');
        if (!button) return;
        this.months = Number(button.dataset.stitchMonths);
        this.render();
      }, { signal: this.abort.signal });
      if (this.dataset.mode === 'details') {
        this.variants = JSON.parse(this.querySelector('[data-stitch-variants]')?.textContent || '[]');
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (String(event.data?.sectionId) !== this.dataset.section) return;
            const variant = this.variants.find((item) => String(item.id) === String(event.data?.variant?.id));
            if (variant) this.setPrice(variant.price);
          });
        }
        document.addEventListener('variant:change', (event) => {
          const variant = this.variants.find((item) => String(item.id) === String(event.detail?.variant?.id));
          if (variant) this.setPrice(variant.price);
        }, { signal: this.abort.signal });
      }
      this.render();
      if (this.dataset.mode !== 'collection') {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.observer.disconnect();
            this.mountOfficial();
          }
        }, { rootMargin: '150px' });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = undefined;
      this.unsubscribe?.();
      this.observer?.disconnect();
      this.widget?.destroy();
      this.widget = undefined;
    }
    setPrice(cents) {
      if (!Number.isFinite(Number(cents)) || Number(cents) < 0) return;
      this.price = Math.round(Number(cents));
      this.dataset.price = String(this.price);
      this.widget?.setPrice(this.price / 100);
      this.render();
    }
    render() {
      this.hidden = !Number.isFinite(this.price) || this.price < 10000;
      const from = this.querySelector('[data-stitch-from]');
      if (from) from.textContent = money(Math.round(this.price / 6));
      const estimate = this.querySelector('[data-stitch-estimate]');
      // Keep the rounding remainder in the first payment so the estimate totals exactly.
      const monthly = Math.floor(this.price / this.months);
      const first = this.price - monthly * (this.months - 1);
      if (estimate) estimate.textContent = `${money(first)} today, then ${this.months - 1} monthly payments of ${money(monthly)}.`;
      this.querySelectorAll('[data-stitch-months]').forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.stitchMonths) === this.months)));
    }
    async mountOfficial() {
      try {
        const api = await loadWidgetLibrary();
        if (!this.isConnected || this.widget) return;
        const mount = this.querySelector('[data-stitch-official]');
        mount.id = `tt-stitch-official-${++sequence}`;
        this.widget = api.createWidget({ mountSelector: `#${mount.id}`, price: this.price / 100, minimumAmount: 100, installments: 6, currency: 'ZAR', locale: 'en-ZA', logoBg: 'purple', width: '100%', backgroundColor: '#f6f4ff' });
        this.querySelector('[data-stitch-fallback]').hidden = true;
      } catch {
        // Keep the local quote usable if the provider script is blocked.
      }
    }
  }
  customElements.define('techtic-stitch', TechTicStitch);
})();
